// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"2a6f6fccf45e7933238a","126":"87ae72a9720752020ef5","127":"1c548d4e00a76a0c7e69","177":"f1af6bafe079d3755ad9"}[chunkId] + ".chunk.js";
};